<template>
  <b-container fluid>
    
    <!----------------------------------------------------Collapse Facturación------------------------------------------------------>
    <b-row v-if="servicios.facturacion" class="margin" align-h="center" no-gutters>
      <b-col cols="12" md="10" lg="8">
        <b-row no-gutters> 
          <b-col>
            <b-img src="@/assets/portadafacturacion.jpg" fluid-grow alt="Fluid-grow image"></b-img>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-row align-h="center">
      <b-col cols="12" md="10" lg="7">
        <docs-tramite :isPublico="true" />
      </b-col>
    </b-row>

    <!--------------------------------------------------------------------- MODALS -------------------------------------------------------------------->

   
  </b-container>
</template>


<script>
//import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import { mapState} from 'vuex';
import { server, handledError, getGetConfig } from '@/axios-tools';
import axios from 'axios';
import Vue from 'vue';
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue';
import DocsTramite from '../cobro/DocsTramite.vue';
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)


export default {
  computed:{
    ...mapState({
    }),
  },
  data(){
    return{
      servicios:{
        facturacion: false,
        pagoAgua: false,
        pagoAnuncios: false,
        pagoBebidas: false,
        pagoComercio: false,
        pagoEnLinea: false,
        pagoEstacionamiento: false,
        pagoJuegos: false,
        pagoPadronMensual: false,
        pagoPanteon: false,
        pagoPredial: false
      },
    }
  },
  components: {
    DocsTramite
  },
  created: function () {
      this.getServices();
    },
  methods:{
    getServices(){
      axios(
        getGetConfig(server.servicios, null, null, {codeClient:this.$route.params.municipio})
      )
      .then(res => {
        this.servicios = res.data;
      }).catch(err => {
        handledError(err, server.servicios, this.$router, this.$store);
      });
    },
   
    
  },
  validations:{
   
    
  }
}
</script>
<style>
.row-to-img-orden{
  margin-left:40px;
}
.button-reenviar{
  margin-top: 5px;
}
.dropdown{
  margin-bottom: 5px;
}
.input-folio{
  margin-top:10px;
}
.input-serie{
  margin-top:10px;
}
.b-icon-info-recibo{
  margin-right:20px;
}
.margin-radio-recibo{
  margin-right:5px;
}
.margin-radio-linea{
  margin-right:5px;
}
.link-pdf{
  margin-left:20px;
}
.margin{
  margin: 5px auto;
}
div.error{
  color: red;
}
div.success{
  color: green;
  margin-bottom: 10px;
}

/*------------------------------------------------------------------------------- THEMS -------------------------------------------------------------------------- */
.teotihuacan:hover{
   background-color:#A03455;
   border-color:#A03455;
}
.teotihuacan{
   background-color:#9D2449; 
   border-color:#9D2449;
}
.demo:hover{
  background-color:#5F58B1;
   border-color:#5F58B1;
}
.demo{
  background-color:#312991; 
   border-color:#312991;
}
</style>